"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonSizeValues = exports.ButtonVariantValues = exports.Button = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var harris_icon_font_1 = __importDefault(require("@rotaryintl/harris-icon-font"));
require("./button.styles.css");
var colorClassMap = {
    primary: 'variant-primary',
    secondary: 'variant-secondary',
    destructive: 'variant-destructive',
    text: 'variant-text',
    tertiary: 'variant-tertiary',
    elevated: 'variant-elevated',
    textAlterative: 'variant-text-alternative',
    outlined: 'variant-outlined',
};
var ButtonVariantValues = [
    'primary',
    'secondary',
    'tertiary',
    'elevated',
    'text',
    'destructive',
    'textAlterative',
    'outlined',
];
exports.ButtonVariantValues = ButtonVariantValues;
var ButtonSizeValues = ['md', 'sm', 'xs'];
exports.ButtonSizeValues = ButtonSizeValues;
var Button = function (_a) {
    var _b = _a.variant, variant = _b === void 0 ? 'primary' : _b, _c = _a.size, size = _c === void 0 ? 'md' : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d, icon = _a.icon, url = _a.url, target = _a.target, clickHandler = _a.clickHandler, children = _a.children, _e = _a.isIconLeftAligned, isIconLeftAligned = _e === void 0 ? true : _e, className = _a.className, rest = __rest(_a, ["variant", "size", "disabled", "icon", "url", "target", "clickHandler", "children", "isIconLeftAligned", "className"]);
    var buttonClasses = (0, classnames_1.default)(className, // from className prop
    'rotaryui-button', colorClassMap[variant], // main button type
    {
        'disabled': disabled,
        'button-size-sm': size === 'sm',
        'button-size-xs': size === 'xs',
    });
    var innerElementWithIconOnRight = ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [children && (0, jsx_runtime_1.jsx)("span", { children: children }), icon ? (0, jsx_runtime_1.jsx)(harris_icon_font_1.default, { type: icon }) : null] }));
    var innerElementWithIconOnLeft = ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [icon ? (0, jsx_runtime_1.jsx)(harris_icon_font_1.default, { type: icon }) : null, children && (0, jsx_runtime_1.jsx)("span", { children: children })] }));
    var returnElement;
    /* Conditionally return A, button, or span element */
    if (url) {
        buttonClasses = (0, classnames_1.default)(buttonClasses, ['link-styles-off']);
        returnElement = ((0, jsx_runtime_1.jsx)("a", __assign({ className: buttonClasses, href: url, target: target === null || target === void 0 ? void 0 : target.trim() }, rest, { children: isIconLeftAligned
                ? innerElementWithIconOnLeft
                : innerElementWithIconOnRight })));
    }
    else {
        returnElement = ((0, jsx_runtime_1.jsx)("button", __assign({ className: buttonClasses, onClick: clickHandler, disabled: disabled }, rest, { children: isIconLeftAligned
                ? innerElementWithIconOnLeft
                : innerElementWithIconOnRight })));
    }
    return returnElement;
};
exports.Button = Button;
exports.default = Button;
//# sourceMappingURL=button.component.js.map